module.exports = __webpack_public_path__ + "img/captainamerica.3dc43f1f.svg";